<template>
	<div class="vue-archive">
		<div :class="parentClass">

			<div v-if="isLoading">
				<div class="col-auto p-5 my-3 text-center border">
					<h2 class="text-muted">Loading</h2>
				</div>
			</div>

			<div v-if="!hasResults" class="row justify-content-center mb-5">
				<div class="col-auto p-5 my-3 text-center border">
					<h2 class="text-muted">No Matching Results</h2>
					<p>Sorry! We haven't been able to find any results for your search.</p>
				</div>
			</div>
			<div class="row">
				<div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-5 event-card-marathon" v-for="post, index in posts.data" :key="post.id">
					<div class="card rounded-tr-xl rounded-tl-xl shadow overflow-hidden h-full position-relative">
						<div class="badges position-absolute left-5 top-0 py-1 px-3 text-white bg-F77D0D" v-if="post.event_date">
							<p class="font-weight-medium mb-0 text-center">{{ post.event_date.month }}</p>
							<h3 class="mb-0 text-center badge-day font-weight-bold">{{ post.event_date.day }}</h3>
							<p class="mb-0 text-center">{{ post.event_date.year }}</p>
						</div>
						<a :href="makeItemLink(post)" class="d-block">
							<img :src="(post.featured_image_url) ? post.featured_image_url : '/images/placeholder.png'" :alt="post.title" class="card-img-top card__img object-fit-cover h-full">
						</a>
						<div class="card-body h-full pb-5 position-relative">
							<h2 class="h4">{{ post.title }}</h2>
							<p class="card-text">{{ post.excerpt }}</p>
							<a class="card-link text-danger position-absolute bottom-5 left-5" :href="makeItemLink(post)">Read More</a>
						</div>
					</div>
				</div>
			</div>
			<div class="row py-5 justify-content-center border-top border-secondary">
				<pagination class="col-auto vue-pagination" :limit="limit" :data="posts" @pagination-change-page="getResults">
					<li slot="prev-nav">&lt;</li>
					<li slot="next-nav">&gt;</li>
				</pagination>
			</div>


		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			posts: {},
			page: 1,
			parentClass: 'loading',
		};
	},
	props: {
		url: {type: String},
		count: {default: 6, type: Number},
		limit: {default: 2, type: Number},
	},
	

	methods: {
		dynamicAttribute: function(prefix, index, key) {
			return prefix + index + "-" + key;
		},
		interpolateAttribute: function(value, prefix = "", suffix = "") {
			return prefix + value + suffix;
		},
		getResults(page = 1) {
			this.parentClass = "loading";
			axios.get(this.url + '?page=' + page + '&count=' + this.count)
				.then(response => {
					console.log(response.data);
					this.posts = response.data;
					this.page = page;
					this.parentClass = "loaded";
				});
		},
		makeItemLink(item) {
			var slug = this.interpolateAttribute(item.slug, '/');
			if (typeof item.prefix !== 'undefined' && item.prefix !== null) {
				slug = this.interpolateAttribute(item.prefix, '/', slug);
			}
			return slug;
		}
	},
	computed: {
		isLoading: function () {
      		return (this.parentClass == 'loading');
		},
		hasResults: function (){
			if (this.parentClass == 'loading') {
				return true;
			}
			if (this.posts != '') {
				return true;
			}
			return false;
		}
	},
	mounted() {
		this.getResults();
	},
	updated() {}
};
</script>
